import { render, staticRenderFns } from "./LP.vue?vue&type=template&id=774122d6&scoped=true"
import script from "./LP.vue?vue&type=script&lang=js"
export * from "./LP.vue?vue&type=script&lang=js"
import style0 from "./LP.vue?vue&type=style&index=0&id=774122d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774122d6",
  null
  
)

export default component.exports